import { plainText } from '../../../utils/richTextHtml';

export function parseChapterTime(value) {
  const text = String(value ?? '').trim();
  if (!/^\d+:\d{2}(?::\d{2})?$/.test(text)) return null;
  const parts = text.split(':').map(Number);
  if (parts.slice(1).some((part) => part > 59)) return null;
  return parts.reduce((seconds, part) => seconds * 60 + part, 0);
}

export function formatChapterTime(seconds) {
  const value = Math.max(0, Math.floor(Number(seconds) || 0));
  const secs = String(value % 60).padStart(2, '0');
  const minutes = Math.floor(value / 60);
  return minutes < 60 ? `${minutes}:${secs}` : `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}:${secs}`;
}

export function chapterError(chapter, chapters, duration) {
  if (!plainText(chapter?.title)) return 'Renseignez le titre sur la vidéo dans la page.';
  if (!Number.isFinite(chapter?.time) || chapter.time < 0) return 'Indiquez un temps au format mm:ss ou h:mm:ss.';
  if (chapters.filter((item) => item.time === chapter.time).length > 1) return 'Deux chapitres ne peuvent pas commencer au même instant.';
  if (Number.isFinite(duration) && duration > 0 && chapter.time >= duration) return 'Ce chapitre dépasse la durée de la vidéo.';
  return null;
}

export function orderedChapters(chapters = [], duration) {
  return chapters.filter((chapter) => !chapterError(chapter, chapters, duration)).slice().sort((a, b) => a.time - b.time);
}

export function currentChapter(chapters, time) {
  return chapters.reduce((current, chapter) => chapter.time <= time ? chapter : current, null);
}
